import { render, staticRenderFns } from "./PSupplementaryExplanation.vue?vue&type=template&id=074cfe8a&"
import script from "./PSupplementaryExplanation.vue?vue&type=script&lang=ts&"
export * from "./PSupplementaryExplanation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports